import { makeStyles } from '@mui/styles';

export const menuWrapperStyle = makeStyles({
  grid: {
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '75vh'
  }
});
